import { cx } from '@linaria/core';
import { useRef } from 'react';
import { TransitionGroup } from 'react-transition-group';
import { useLoaderState, CSSRefTransition } from '@utils/react';
import { ErrorMessage } from '../atoms/ErrorMessage.js';
import { Throbber } from '../atoms/Throbber.js';
import { useMediaPlayer } from '../hook.media-player.js';
import { containerCls, tokens, fadeTransitionCls, FADE_TRANSITION_DURATION_MS, skeleton__wrapperCls, skeleton__durationCls, skeleton__volumeCls, skeleton__titleCls, playerCls } from './audio-component.content.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function AudioComponentContent(props) {
  const playerRef = useRef(null);
  const {
    didError,
    loading
  } = useMediaPlayer(playerRef, {
    type: "audio",
    src: props.src,
    caption: props.caption,
    autoPlay: props.autoPlay,
    displayInternalInfo: props.displayInternalInfoInPlayer
  });
  const showThrobber = useLoaderState(loading, {
    delayMs: 750,
    durationMs: 650
  });
  return /*#__PURE__*/jsxs("span", {
    className: containerCls,
    style: tokens.__override({
      backgroundColor: didError ? "#f3f3f3" : undefined
    }),
    children: [/*#__PURE__*/jsxs(TransitionGroup, {
      component: null,
      children: [loading && !didError && /*#__PURE__*/jsx(CSSRefTransition, {
        classNames: fadeTransitionCls,
        timeout: FADE_TRANSITION_DURATION_MS,
        children: ref => /*#__PURE__*/jsxs("span", {
          ref: ref,
          role: "presentation",
          className: skeleton__wrapperCls,
          children: [/*#__PURE__*/jsx("span", {
            className: skeleton__durationCls
          }), /*#__PURE__*/jsx("span", {
            className: skeleton__volumeCls
          }), /*#__PURE__*/jsx("span", {
            className: skeleton__titleCls
          })]
        })
      }, "skeleton"), didError && /*#__PURE__*/jsx(CSSRefTransition, {
        classNames: fadeTransitionCls,
        timeout: FADE_TRANSITION_DURATION_MS,
        children: ref => /*#__PURE__*/jsx(ErrorMessage, {
          ref: ref
        })
      }, "error"), showThrobber.current && !didError && /*#__PURE__*/jsx(CSSRefTransition, {
        classNames: fadeTransitionCls,
        timeout: FADE_TRANSITION_DURATION_MS,
        children: ref => /*#__PURE__*/jsx(Throbber, {
          ref: ref,
          height: 50
        })
      }, "throbber")]
    }), /*#__PURE__*/jsx("span", {
      className: cx(playerCls, (loading || showThrobber.current || didError) && "hidden"),
      children: /*#__PURE__*/jsx("span", {
        style: {
          width: "100%",
          height: "100%"
        },
        ref: playerRef
      })
    })]
  });
}

export { AudioComponentContent };
//# sourceMappingURL=audio-component.content.js.map
